"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MapDrawOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var MapDrawOutlineSVG = function MapDrawOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29.8 5.11L26.89 2.2a.67.67 0 00-.48-.2.7.7 0 00-.49.2l-6.73 6.74L19 9l-8.86-2.95a.54.54 0 00-.28 0L3.45 7.59A2 2 0 002 9.51v16.84a2 2 0 002 2 2.15 2.15 0 00.55-.08L9.86 27a.61.61 0 01.27 0l8.7 2.9a.47.47 0 00.33 0l6.63-2.42a2 2 0 001.21-1.8V8.89l2.8-2.81a.68.68 0 000-.97zM9 25.22l-5 1.13V9.51l5-1.26zm9 2.45l-7-2.34V8.38l6.36 2.38-3.72 3.73a.42.42 0 00-.14.28l-.5 3.45a.69.69 0 00.19.58.67.67 0 00.48.2l3.55-.5a.42.42 0 00.28-.14l.49-.49zm-1.55-11.08l-1.22.18.18-1.22L20.93 10l2.9-2.9 1 1-3.28 3.28zM25 25.68l-5 1.93V15.88l2-2 3-3zm1.22-18.86l-1-1 1.3-1.3 1 1z"
  }));
};
exports.MapDrawOutlineSVG = MapDrawOutlineSVG;
MapDrawOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(MapDrawOutlineSVG);
exports.default = _default;